<template>
    <section class="page-section">
        <div class="drop-zones-header">
            <div :class="{'activated':viewState.activateClocks}">Monday</div>
            <div :class="{'activated':viewState.activatePlaylists}">Tuesday</div>
            <div :class="{'activated':viewState.activatePodcasts}">Wednesday</div>
            <div :class="{'activated':viewState.activatePodcasts}">Thursday</div>
            <div :class="{'activated':viewState.activatePodcasts}">Friday</div>
            <div :class="{'activated':viewState.activatePodcasts}">Saturday</div>
            <div :class="{'activated':viewState.activatePodcasts}">Sunday</div>
        </div>

        <WaitingBlock v-if="isLoadingDayTemplateItems"></WaitingBlock>
        <div v-else class="drop-zones" v-on:drop="drop" v-on:dragover="dragOver" >
            <div class="" style="height: 100px!important">
            </div>
            <div class="drop-zones-container">
                <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[1].name? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved" >
                    <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                        <BaseWeekScheduledItemCard
                                               :type="'1'" :scheduledItem="currentWeekTemplateItems.template[1]"
                                               key="1"
                                               @onScheduledItemMoving="onScheduledItemStartMoving"
                                               @onScheduledItemEditing="onScheduledItemEditing"
                                               @onScheduledItemDeleting="onScheduledItemDeleting"
                                               @mouseup.prevent.stop="onScheduledItemMoved">
                        </BaseWeekScheduledItemCard>
                    </template>
                </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[2].name!=null ? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'2'" :scheduledItem="currentWeekTemplateItems.template[2]"
                                             key="2"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[3].name!=null ? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'3'" :scheduledItem="currentWeekTemplateItems.template[3]"
                                             key="3"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[4].name!=null ? 'none' : '1px dashed #a6a6a6'}"  @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'4'" :scheduledItem="currentWeekTemplateItems.template[4]"
                                             key="4"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[5].name!=null ? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'5'" :scheduledItem="currentWeekTemplateItems.template[5]"
                                             key="5"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[6].name!=null ? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'6'" :scheduledItem="currentWeekTemplateItems.template[6]"
                                             key="6"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>
              <div class="drop-zone-clocks" :style="{border: currentWeekTemplateItems.template[0].name!=null ? 'none' : '1px dashed #a6a6a6'}" @mousemove="onScheduledItemMove" @mouseup.prevent.stop="onScheduledItemMoved">
                <template  class="vl" v-if="currentWeekTemplateItems.template!=null">
                  <BaseWeekScheduledItemCard
                                             :type="'0'" :scheduledItem="currentWeekTemplateItems.template[0]"
                                             key="0"
                                             @onScheduledItemMoving="onScheduledItemStartMoving"
                                             @onScheduledItemEditing="onScheduledItemEditing"
                                             @onScheduledItemDeleting="onScheduledItemDeleting"
                                             @mouseup.prevent.stop="onScheduledItemMoved">
                  </BaseWeekScheduledItemCard>
                </template>
              </div>

            </div>
        </div>
<!--            <div  style="position: absolute ; margin-top: 50px; right: 15px"  >-->
<!--              <Button :empty="false" class="validate" :disabled="!isWeekDayFull" @click.prevent="createWeekTemplate" > Save </Button>-->
<!--            </div>-->

      <div  style="position: absolute ; margin-top: 50px; right: 15px"  id="tooltip-button-disable">
        <span style=" margin-bottom: 50px" >
          <Button :empty="false" class="validate" :disabled="!isWeekDayFull" @click.prevent="createWeekTemplate" > Save</Button>
        </span>
      </div>
      <b-tooltip :disabled.sync="isWeekDayFull" ref="tooltip" target="tooltip-button-disable">
       You have to fill in the 7 days
      </b-tooltip>

    </section>

</template>

<script>
    import store from '@/store/index.js';
    import WaitingBlock from'@/components/common/WaitingBlock.vue';
    import ItemListCard from'@/components/common/PlannerItemListCard.vue';

    import BaseWeekScheduledItemCard from '@/components/weekTemplate/BaseWeekScheduledItemCard'
    import Enums from '../../apis/_enums'
    import Translations from '@/store/translations';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';
    import Moment from 'moment';
    import EventBus from '@/eventbus';
    import { HTTP } from "@/utils/http";
    import Apis from "@/apis";
    import {safeObj} from "@/utils/safeObj";

    const MOVING_MODES = {
        RESIZE: "resize", MOVE: 'move'
    }
    export default {
        name: "WeekTemplateDetails",
        store,
        //------------------------------------------------------------------------------------------------------------------------------------------------
        components: { WaitingBlock, ItemListCard, BaseWeekScheduledItemCard },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        //------------------------------------------------------------------------------------------------------------------------------------------------
        mounted() {
            EventBus.$on('dragStart', this.dragStart);
            EventBus.$on('dragEnd', this.dragEnd);

            this.stationUid = this.$route.params.stationUid;
            this.dayTemplateUid = this.$route.params.dayTemplateUid;
            this.loadWeekTemplate();
            this.loadWeekTemplateScheduledItemList();
            this.loadWeekTemplate();
        },
        beforeDestroy () {
            EventBus.$off('dragStart', this.dragStart);
            EventBus.$off('dragEnd', this.dragEnd);
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        watch: {
            '$route': function (to, from) {
                this.stationUid = this.$route.params.stationUid;
                this.dayTemplateUid = this.$route.params.dayTemplateUid;
                this.loadWeekTemplate();
                this.loadWeekTemplateScheduledItemList();
                this.$store.dispatch('loadStationDayTemplates', this.$route.params.stationUid)
            },
          'dtList':{
            deep: true,
            handler: function (newValue) {
              console.log('------------------------------------------------')
              this.loadData(newValue, this);

            }
          },
          'scheduledItem': {
            handler: function (newValue) {
              console.log(newValue)
              console.log('scheduledItem')
              //"dt-item-card 4" dragTemplate
              switch (newValue.typeId) {
                case 'dt-item-card 1':  this.dragTemplate(newValue , 1);  break;
                case 'dt-item-card 2':  this.dragTemplate(newValue , 2);  break;
                case 'dt-item-card 3':  this.dragTemplate(newValue , 3);  break;
                case 'dt-item-card 4':  this.dragTemplate(newValue , 4);  break;
                case 'dt-item-card 5':  this.dragTemplate(newValue , 5);  break;
                case 'dt-item-card 6':  this.dragTemplate(newValue , 6);  break;
                case 'dt-item-card 0':  this.dragTemplate(newValue , 0);  break;
              }

              console.log('watch scheduledItem' , newValue);
              console.log('watch scheduledItem' , this.currentWeekTemplateItems);
             console.log(JSON.stringify(this.mapPostData()));
             this.isWeekDayFullCheck();
            },
          }
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        computed: {
          ...mapState({
            isLoadingDayTemplates: state => state.loadingStates.isLoadingStationDayTemplates,
            dtList: state => state.stationDayTemplates,
          }),
            scheduledItemTypes() {
                return Enums.ScheduledItemTypes;
            },
            Translations: () => Translations,
            intervals: function () {
                var definedZoom = this.viewState.zoomLevels.find(val => val == this.viewState.zoom);
                if (!definedZoom) this.viewState.zoom = definedZoom = 30;
                var stepCount = 1440 / this.viewState.zoom;
                var intervals = [];
                for (var i = 0; i < stepCount; i++) {
                    var tmpDate = Moment().utc().startOf('day').add(i * definedZoom, "m");
                    var tmpDateTo = Moment().utc().startOf('day').add((i + 1) * definedZoom, "m");
                    intervals.push({ minStart: i * definedZoom, minEnd: (i + 1) * definedZoom, timeStart: tmpDate, timeEnd: tmpDateTo, step: i })
                }
                return intervals;
            },
            postData() {
                if (!!Object.keys(this.activeMovingItem).length  && this.activeMovingItem.scheduledItem == null) {
                    return null;
                }
                var draft = Object.assign({}, this.activeMovingItem.scheduledItem);
                draft.stationUid = this.$route.params.stationUid;
                draft.dayTemplateUid = this.$route.params.dayTemplateUid;
                draft.from = this.minToMoment(draft.minuteFrom).format("HH:mm:ss");
                draft.to = this.minToMoment(draft.minuteTo).format("HH:mm:ss");
                draft.minuteFrom = parseInt(draft.minuteFrom);
                draft.minuteTo = parseInt(draft.minuteTo);
                draft.minuteTo = draft.minuteTo === 0 || draft.minuteTo > 1440 ? 1440 : draft.minuteTo;
                return draft;
            },
            currentApi() {
                // SHOULD BE CENTRALIZED
                switch ((this.postData || {}).typeId) {
                    case this.scheduledItemTypes.DAYTEMPLATE_CLOCK.value: return Apis.daytemplates.linkClock;
                    case this.scheduledItemTypes.DAYTEMPLATE_PLAYLIST.value: return Apis.daytemplates.linkPlaylist;
                    case this.scheduledItemTypes.DAYTEMPLATE_PODCAST.value: return Apis.daytemplates.linkPodcast;
                    case this.scheduledItemTypes.DAYTEMPLATE_PROMO.value: return Apis.daytemplates.linkPromo;
                    default: return null;
                }
            },
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        data() {
            var defaultMovingItem = { scheduledItem: null };
            return {
                currentDayTemplate: null,
                isWeekDayFull:false,
                reponseWeekTemplate:null,
                viewState: {
                    isLoadingDayTemplate: false,
                    zoomLevels: [5, 15, 30, 60],
                    zoom: 30,
                    activatePlaylists: true,
                    activatePodcasts: true,
                    activateClocks: true,
                    defaultMovingItem: defaultMovingItem
                },
                isLoadingDayTemplateItems: true,
                currentWeekTemplateItems: null,
                activeMovingItem: defaultMovingItem,
                scheduledItem: null,
                scheduledItemToDelete: null
            }
        },
        //------------------------------------------------------------------------------------------------------------------------------------------------
        methods: {
          makeToast(msg , type , title) {
            this.$store.dispatch('Toasts/addToast', {
                title: title,
                message: msg,
                type: type
            });
          },
             createWeekTemplate() {
               const response =   HTTP.post(Apis.weektemplates.create, this.mapPostData())
                   .then((response) => {
                     if(response.status === 200){
                       this.makeToast('Updated successfully', 'success' ,'Success')
                     } else{
                       this.makeToast('Failed to save week template', 'danger' ,'Error')
                     }
                   });


               },
          isWeekDayFullCheck(){
            console.log('isWeekDayFullCheck')
            this.isWeekDayFull = true;
            for (let i = 0; i < 7; i++) {
              if(!this.currentWeekTemplateItems.template[i].name){
                this.isWeekDayFull = false;
              }
            }
            this.$forceUpdate();

          },
          mapPostData(){
               let data;
            data = {
            stationUid:  this.$route.params.stationUid,
              'daysOfWeekPerTemplateUid': new Map()
            }
            for (let i = 0; i < 7; i++) {
              if(!this.currentWeekTemplateItems.template[i].name)
              continue;
              let curTemp = this.currentWeekTemplateItems.template[i];
              if (!data.daysOfWeekPerTemplateUid.has(curTemp.boxuid)) {
                data.daysOfWeekPerTemplateUid.set(curTemp.boxuid, new Array());
              }
              data.daysOfWeekPerTemplateUid.get(curTemp.boxuid).push(i)
            }
            return {stationUid : data.stationUid, daysOfWeekPerTemplateUid: Object.fromEntries(data.daysOfWeekPerTemplateUid)};
          },
             dragTemplate(newValue , day){
               console.log(newValue , day)
               this.currentWeekTemplateItems.template[day] ={boxuid:newValue.boxuid,
                   colorCode:newValue.colorCode,
                   from:newValue.from,
                   minuteFrom:newValue.minuteFrom,
                   name:newValue.name,
                   recordUid: newValue.recordUid,
                   typeId:day};
               console.log('----------------------' , this.currentWeekTemplateItems.template)
               this.$forceUpdate();
             },
            onWeekTemplateLoaded(response) {
             this.reponseWeekTemplate= response.data.dataItem;
             this.loadData(this.dtList, this);
            },
            onWeekTemplateLoadError(response) {  },
            onWeekTemplateLoadComplete(response) { this.viewState.isLoadingDayTemplate = false; },
            loadWeekTemplate: function () {
                this.viewState.isLoadingDayTemplate = true;
                HTTP.get(Apis.weektemplates.list, { params: this.$route.params })
                    .then(this.onWeekTemplateLoaded, this.onWeekTemplateLoadError)
                    .then(this.onWeekTemplateLoadComplete);
                if (this.$route.params != null && this.$route.params.stationUid != null && this.$route.params.dayTemplateUid != null) {
                    store.dispatch("loadWeekTemplate", this.$route.params);
                }
            },
            addClock(clock) {
                 console.log("AddClock : ",clock)
                var data = { typeId: this.scheduledItemTypes.DAYTEMPLATE_CLOCK.value, recordUid: null, clockUid: clock.uid, minuteFrom: 0, minuteTo: 1440, name: clock.name, autoSelect: true }
                this.scheduledItem = data;
            },
            addPlaylist(playlist) {
                console.log("addPlaylist : ",playlist)
                var data = { typeId: this.scheduledItemTypes.DAYTEMPLATE_PLAYLIST.value, recordUid: null, boxuid: playlist.uid, minuteFrom: 0, name: playlist.name }
                this.scheduledItem = data;
            },
            addTemlate(template , type) {
              console.log('addTemlate')
                console.log("add : ",template)
                console.log("add : ",type)
                var data = { typeId: type, recordUid: null, boxuid: template.uid, minuteFrom: 0, name: template.name, repeat: false, repeatCount: 0, repeatDelay: 60 , colorCode: template.colorCode }
                this.scheduledItem = data;
                console.log("++++++++------ : ",this.scheduledItem)
            },
          loadData(newValue, thiss){
            console.log('loadData' , thiss.currentWeekTemplateItems)
            let weekTemplate = this.reponseWeekTemplate;

            thiss.currentWeekTemplateItems = {'template' : []};
            Object.keys(weekTemplate.daysOfWeekPerTemplateUid).forEach(function (key) {
              let source = newValue.items.filter(elt => elt.uid === key);
              if (source && source[0]) {
                for (let i = 0; i < weekTemplate.daysOfWeekPerTemplateUid[key].length; i++) {
                  console.log(weekTemplate.daysOfWeekPerTemplateUid)
                  console.log(source[0], 'dt-item-card ' + weekTemplate.daysOfWeekPerTemplateUid[key][i])
                  let template =source[0];

                  thiss.currentWeekTemplateItems.template[weekTemplate.daysOfWeekPerTemplateUid[key][i]] ={boxuid:template.uid,
                    colorCode:template.colorCode,
                    from:'00:00',
                    minuteFrom:'00:00',
                    name:template.name,
                    recordUid: '00:00',
                    typeId:weekTemplate.daysOfWeekPerTemplateUid[key][i]};
                  console.log('----------------------' , thiss.currentWeekTemplateItems.template)
                  thiss.$forceUpdate();
                }


              }
            })
            if(thiss.currentWeekTemplateItems.template.length===0){
              this.currentWeekTemplateItems = {"template" :[]};
              for (var i = 0; i < 7; i++) {
                this.currentWeekTemplateItems.template[i] = {
                  boxuid: '',
                  colorCode: '',
                  from: null,
                  minuteFrom: 0,
                  name: null,
                  recordUid: null,
                  typeId: i
                };
              }
            }
            this.currentWeekTemplateItems.template = thiss.currentWeekTemplateItems.template;
            this.$forceUpdate();
          },
            //-------------------------------------------------------------------------------------------
            //- Edition & remove actions
            //-------------------------------------------------------------------------------------------
            onScheduledItemListUpdated(response) {
            },
            onScheduledItemEditing(e, data) {
                this.scheduledItem = data.scheduledItem;
                // Open Modal
            },
            onScheduledItemEdited(e, data) {
                // reload items
                this.loadWeekTemplateScheduledItemList();
            },
          getDaysId(type){
            let dayId;
            switch (type) {
              case 'dt-item-card 1':  dayId = 1;  break;
              case 'dt-item-card 2':  dayId = 2;  break;
              case 'dt-item-card 3':  dayId = 3;  break;
              case 'dt-item-card 4':  dayId = 4;  break;
              case 'dt-item-card 5':  dayId = 5;  break;
              case 'dt-item-card 6':  dayId = 6;  break;
              case 'dt-item-card 0':  dayId = 0;  break;
            }
            return   dayId;
          },
            //-------------------------------------------------------------------------------------------
            //- Api
            //-------------------------------------------------------------------------------------------
            loadWeekTemplateScheduledItemList() {
                this.viewState.isLoadingScheduledItems = true;
                HTTP
                    .get(Apis.daytemplates.scheduledItems, { params: { stationUid: this.stationUid, dayTemplateUid: this.dayTemplateUid }})
                    .then(this.onScheduledItemListLoadComplete, this.onClockBoxListLoadError)
                    .then(() => {
                        this.viewState.isLoadingScheduledItems = false;
                    });
            },
            onScheduledItemDeleting(e, data) {},
            onScheduledItemListLoadComplete: function (response) {
                console.log('------onScheduledItemListLoadComplete++++++', response)
                this.scheduledListResponse = response.data;
                console.log(this.currentWeekTemplateItems)
              if (this.currentWeekTemplateItems && !this.currentWeekTemplateItems.template && this.currentWeekTemplateItems.template.length < 6){
              this.currentWeekTemplateItems = {"template" :[]};
              for (var i = 0; i < 7; i++) {
                this.currentWeekTemplateItems.template[i] = {
                  boxuid: '',
                  colorCode: '',
                  from: null,
                  minuteFrom: 0,
                  name: null,
                  recordUid: null,
                  typeId: i
                };
              }
              }
                console.log('------onScheduledItemListLoadComplete++++++',  this.currentWeekTemplateItems)
                this.isLoadingDayTemplateItems = false;
                this.isWeekDayFullCheck();
            },
            onScheduledItemListLoadError: function (error) {
                this.scheduledListResponse = error.response.data;
            },
            onScheduledItemMoved(e) {
                console.log('onScheduledItemMoved')
            },
            onItemMoved() {

            },
            refreshData(response) {
              console.log('------refreshData+++++', response)
                // console.log(JSON.stringify(response));
                this.scheduledListResponse = response;
                var data = response.dataItem || [];
                this.preparePodcasts(data);
                this.currentWeekTemplateItems = data;
            },
            onApiSaved(httpResponse) {
            },
            onApiError(error) {
                this.apiResponse = error.response.data;
                this.refreshData(this.apiResponse);
                console.error(this.apiResponse);
            },
            //-------------------------------------------------------------------------------------------
            //- Tools
            //-------------------------------------------------------------------------------------------
            preparePodcasts(data) {
                if (!data) return;
                var workingData = (data.podcasts || []).sort(function (a, b) { return b.minuteFrom - a.minuteFrom });
                //console.log(JSON.stringify(data.podcasts));
                //console.log("Redraw podcasts");
                // To Force the display if more than one podcast at the same period
                var intervalPodcasts = {}
                for (var i = 0; i < workingData.length; i++) {
                    var pod = workingData[i];
                    for (var idx = 0; idx < this.intervals.length; idx++) {
                        var interval = this.intervals[idx];
                        if (pod.minuteFrom >= interval.minStart && pod.minuteFrom < interval.minEnd) {
                            intervalPodcasts[idx] = (intervalPodcasts[idx] || {});
                            //intervalPodcasts[idx + 1] = (intervalPodcasts[idx + 1] || {});
                            var idxKeys = intervalPodcasts[idx];
                            if (idxKeys[pod.recordUid]) continue;
                            pod.interval = {
                                idx, limits: interval, displayOrder: Object.keys((intervalPodcasts[idx] || {})).length || 0
                            };
                            intervalPodcasts[idx][pod.recordUid] = true;
                            //intervalPodcasts[idx + 1][pod.recordUid] = true;
                        }
                    }
                }
                for (var i = 0; i < workingData.length; i++) {
                    var pod = workingData[i];
                    //console.log(JSON.stringify(pod.recordUid), pod.interval.idx, Object.keys((intervalPodcasts[pod.interval.idx])).length);
                    pod.interval.ratio = 100 / (Object.keys((intervalPodcasts[pod.interval.idx] || {})).length || 1);
                    //console.log(pod.recordUid, "----->xx", pod.interval.ratio, pod.interval.displayOrder);
                    Vue.set(pod, 'interval', pod.interval);
                }
            },
            pxToMin(position, height) {
                return 1440 * (position / height);
            },
            //-------------------------------------------------------------------------------------------
            //- Moving
            //-------------------------------------------------------------------------------------------
            onScheduledItemStartMoving(e, data) {
                console.log('onScheduledItemStartMoving')
                console.log(data)
                this.currentWeekTemplateItems.template[data.type] = {
                  boxuid: '',
                  colorCode: '',
                  from: null,
                  minuteFrom: 0,
                  name: null,
                  recordUid: null,
                  typeId: data.type
                };
                this.isWeekDayFullCheck();
                this.$forceUpdate();
                //console.log("onScheduleItemMoving");
                var source = [];
                source = this.currentWeekTemplateItems.template;

                source = source.filter(elt => elt.recordUid !== data.scheduledItem.recordUid);
                this.activeMovingItem = this.buildMovingData(e, source, data);
                //console.log("onScheduleItemMoving", JSON.stringify(this.activeMovingItem));
                this.isWeekDayFull = false;
            },
            buildMovingData(e, source, data) {
            console.log('buildMovingData')
                //console.log("BuildMovingData")
                var scrollingParent = null;
                var cardParent = null;
                var originalScrollPosition = 0;
                var parentTmp = e.currentTarget;
                if (parentTmp.classList.contains('dt-item-card')) {
                    cardParent = parentTmp;
                }
                while ((parentTmp = parentTmp.parentElement) != null) {
                    if (parentTmp.classList.contains('dt-item-card')) {
                        cardParent = parentTmp;
                    }
                    if (parentTmp.classList.contains("drop-zones-container")) {
                        //console.log(parentTmp, parentTmp.offsetHeight);
                        scrollingParent = parentTmp;
                        originalScrollPosition = parentTmp.scrollTop;
                        break;
                    }
                }

                var movingData = {

                    scheduledItem: data.scheduledItem,
                    mode: data.mode,
                    up: data.up,
                    min: 0,// beginning of a day
                    max: 1440, // total minutes in a day

                    originalStart: data.scheduledItem.minuteFrom,
                    originalEnd: data.scheduledItem.minuteTo,

                    originalMousePosition: { clientX: e.clientX, clientY: e.clientY },
                    containerHeight: scrollingParent.offsetHeight,
                    height: cardParent.offsetHeight,// Scheduled Item Card
                };
                for (var i = 0; i < source.length; i++) {
                    //------------------------------------------------------
                    var candidate = source[i];
                    var candidateFrom = candidate.minuteFrom;
                    var candidateTo = candidate.minuteTo;
                    var currentFrom = data.scheduledItem.minuteFrom;
                    var currentTo = data.scheduledItem.minuteTo;
                    //------------------------------------------------------
                    if (candidateFrom < currentFrom) {
                        movingData.min = candidateTo > movingData.min ? candidateTo : movingData.min;
                    }
                    else {
                        movingData.max = candidateFrom < movingData.max ? candidateFrom : movingData.max;
                    }
                    //------------------------------------------------------
                }
                //console.log(JSON.stringify(movingData));
                return movingData;
            },
            onPodcastMove(e) {
                if (this.activeMovingItem == null) return;
                try {
                    this.onScheduledItemMove(e);
                } catch (e) {
                    console.log(e);
                }
                finally {
                    this.preparePodcasts(this.currentWeekTemplateItems);
                }
            },
            onScheduledItemMove(e) {
               // console.log('onScheduledItemMove' , e)
                if (safeObj(this.activeMovingItem) && this.activeMovingItem.scheduledItem === null) {
                    return;
                }
                if (e.buttons === 1) {
                    var sch = this.activeMovingItem;
                    //console.log("Initial value : ", JSON.stringify(sch))
                    //console.log("Initial value : ", sch.scheduledItem.minuteFrom)
                    var pixDecal = e.clientY - ((sch.originalMousePosition || {}).clientY || 0);
                    //console.log("Décalage Pixels : ", pixDecal, sch.containerHeight)
                    //-----------------------------------------------------------
                    // Convert pix decal to minutes
                    //-----------------------------------------------------------
                    var mDecal = this.pxToMin(pixDecal, sch.containerHeight);
                    //-----------------------------------------------------------
                    // Check Start
                    //-----------------------------------------------------------
                    if (sch.mode === MOVING_MODES.MOVE || sch.up === true) {
                        sch.newStart = sch.originalStart + mDecal;
                        if (sch.newStart < 0) { sch.newStart = 0; }
                        if (sch.newStart < sch.min) sch.newStart = sch.min;
                        // Move only up
                        if (sch.mode === MOVING_MODES.MOVE) {
                            // console.log("Move Only : ")
                            if (sch.newStart + sch.scheduledItem.minuteDuration > sch.max)
                                sch.newStart = sch.max - (sch.scheduledItem.minuteDuration);
                        } else if (sch.up) {
                            // console.log("Resize up : ", sch.newStart)
                            sch.scheduledItem.minuteDuration = sch.scheduledItem.minuteTo - sch.newStart;
                        }
                    }
                    else {
                        sch.newStart = sch.originalStart;
                        // Check to not override day
                        sch.newEnd = Math.min(sch.originalEnd + mDecal, 1440);
                        sch.scheduledItem.minuteDuration = sch.newEnd - sch.newStart;
                        // Resize Down
                        //console.log("Resize down : ", sch.newEnd)
                    }

                    //-----------------------------------------------------------
                    // Check End
                    //-----------------------------------------------------------
                    sch.newEnd = sch.newStart + sch.scheduledItem.minuteDuration;
                    if (sch.newEnd > 1440) { sch.newEnd = 1440; sch.newStart = sch.newEnd - sch.scheduledItem.minuteDuration }
                    if (sch.newEnd > sch.max) sch.newEnd = sch.max;
                    //console.log("-> new end : ",sch.newEnd);

                    // Validate render
                    sch.scheduledItem.minuteFrom = sch.newStart;
                    if (sch.scheduledItem.minuteTo != null)
                        sch.scheduledItem.minuteTo = sch.newEnd;
                }

            },
            // DnD
            dragStart(e, item, type) {
                this.current = { item, type};
            },
            dragOver(e) {
                // Fix for drop to launch
                e.preventDefault();
            },
            dragEnd(e, item) {
                this.current = null;
            },
            drop(e) {
              // console.log(e , this.current)
              // console.log(e.path[0].firstChild.className)
              console.log(e)
              console.log( e.target.firstChild._prevClass)
              let path = e.target.firstChild._prevClass;

                if (!this.current) {
                    return;
                }
                if (path && path.search("dt-item-card") ===-1){
                  path = null;
                }
                if(!path){
                  // for (let i = 0; i < e.path.length; i++) {
                  //   if (e.path[i].className && e.path[i].className.search("dt-item-card") !==-1){
                  //     path =e.path[i].className;
                  //   }
                  // }
                  path = e.target.className
                }
                console.log(path , path.search("dt-item-card"))

                this.addTemlate(this.current.item , path);


            }
        }
    }

</script>
<style lang="scss" scoped>

    .drop-zones-header {
        padding-left: 60px;
        padding-right: 10px;
        background: white;
        display: flex;
        color: #AAAAAA;
        font-size: 13px;
        justify-content: space-between;
        line-height: 48px;
        /* Sticky config ----------------------*/
        position: sticky;
        z-index: 10;
        top:0;

        &::before {
            content: '';
            position: absolute;
            left: -15px;
            bottom: 0;
            z-index: -1;
            width: calc(100% + 30px);
            height: 1px;
            background-color: #D2D2D2;
        }

        &::after {
            content: '';
            position: absolute;
            left: -15px;
            bottom: 0;
            z-index: -2;
            width: calc(100% + 30px);
            height: 100%;
            background-color: #fff;
        }
    }

        .drop-zones-header > div {
            width: 33%;
            margin: 0 5px;
            padding: 18px 0;
            line-height: 1;
            text-align: center;
        }

            .drop-zones-header > div.activated {
                font-weight: 600;
            }

    .drop-zones {
        position: relative;
        z-index: 1;
        justify-content: space-between;
        margin: 15px 0 35px 0;


        &::before {
            content: '';
            position: absolute;
            left: -15px;
            top: -15px;
            z-index: -1;
            width: calc(100% + 30px);
            height: calc(100% + 65px);
            background-color: #F5F6F7;
        }
    }


    .drop-zones-container {
        position: absolute;
        top: 0;
        display: flex;
        height: 100%;
        width: calc(100% - 60px);
        margin-left: 50px;
        justify-content: space-between;
    }

        .drop-zones-container > div {
            height: 100%;
            flex-grow: 1;
            /*background: rgba(255, 255,255,0.5);*/
            margin: 0 5px;
            position: relative;
            width: 33%;
        }

    .time-line-row {
        display: flex;
        height: 40px;
        background-color: white;
    }

        .time-line-row:last-child {
            border-bottom: 1px solid #D2D2D2;
        }

    .helper {
        border-top: 1px solid #D2D2D2;
        width: 100%;
        margin-left: 10px;
    }

    .time-line-label {
        font-size: 13px;
        line-height: 40px;
        color: #888888;
        font-weight: 400;
        margin-top: -20px;
    }
    .vl {
      border-left: 6px solid green;
      height: 500px;
      padding-right: 150px;
    }
</style>
